module.exports = __webpack_public_path__ + "img/icon-user-2.2f8c65bd.svg";